module.exports = new __parcel__URL__("status-simple.c551b891.svg").toString();